/**
 * Gestión de una imagen
 *
 * @link https://www.mendikat.net
 * @author Javi Urrutia <javi@mendikat.net>
 * @copyright 2023-2026 Mendikat
 * @license Mendikat
 *
 */

const vm = new Vue({
    el: '#app',
});
